export default __webpack_public_path__ + "static/media/mob-abt.9fc695c9.jpg";